export default __webpack_public_path__ + "static/media/store.c4ecb971.png";